import script from "./SfxSearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxSearchBar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QList,QItem,QItemSection,QItemLabel,QSeparator,QBadge});qInstall(script, 'directives', {ClosePopup,Ripple});
